import { useStableProps } from '@/hooks/useStable';
import { StandaloneArticleHeader } from 'base/components/ArticleHeader';

export const SvenskdamStandaloneArticleHeader: typeof StandaloneArticleHeader = (props) => {
  const stableProps = useStableProps({ options: { variant: 'first' } }, props);

  return <StandaloneArticleHeader {...stableProps} />;
};

export default SvenskdamStandaloneArticleHeader;
